// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1nYwD","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2mKBC"};